import {
  Checkbox,
  CheckboxGroup as HeroCheckboxGroup,
  CheckboxGroupProps as HeroCheckboxGroupProps,
} from '@heroui/react'
import { motion } from 'framer-motion'

interface Option {
  key: string
  label: string
}

export interface CheckboxGroupProps
  extends Omit<HeroCheckboxGroupProps, 'value' | 'onValueChange' | 'name'> {
  label: string
  classNameContainer?: string
  options: Option[]
  name?: string
  value?: string[]
  onChange?: (value: string[]) => void
  onBlur?: () => void
  errorMessage?: string
}

const CheckboxGroup = ({
  label,
  classNameContainer,
  options,
  name,
  value,
  onChange,
  onBlur,
  errorMessage,
  ...props
}: CheckboxGroupProps) => {
  return (
    <motion.div className={classNameContainer}>
      <HeroCheckboxGroup
        errorMessage={errorMessage}
        isInvalid={Boolean(errorMessage)}
        label={label}
        name={name}
        value={value || []}
        onBlur={onBlur}
        onValueChange={onChange}
        {...props}
        classNames={{
          wrapper: 'flex flex-row gap-8',
          label: 'text-xs text-[#2A3580]',
          ...props.classNames,
        }}
      >
        {options.map((option: Option) => (
          <Checkbox
            key={option.key}
            value={option.key}
            classNames={{
              label: 'text-[#2A3580]',
              base: 'flex gap-1 items-center',
            }}
          >
            {option.label}
          </Checkbox>
        ))}
      </HeroCheckboxGroup>
    </motion.div>
  )
}

export default CheckboxGroup
